'use client';

import { useInvestorQuery } from '@/hooks/use-investor-query';
import { fetchInvestorTransactions } from '../api/get-investor-transactions';
import { portfolioKeys } from '@/lib/investor-keys';
import type {
  InvestorTransactionsQuery,
  InvestorTransactionsResponse
} from '../types/api';

export function useTransactions(
  params: InvestorTransactionsQuery,
  // The ledger a reader pages through stays on the 60s default. A caller
  // that only annotates a chart with it passes a slower cadence.
  { cadenceMs }: { cadenceMs?: number } = {}
) {
  return useInvestorQuery<InvestorTransactionsResponse>({
    key: ({ address, chainId }) =>
      portfolioKeys.transactions(address, chainId, params.page, params.limit),
    fetch: ({ address, chainId }, signal) =>
      fetchInvestorTransactions(address, params, chainId, signal),
    // Paging must not blank the table, but rows from a previous wallet must
    // never appear under this one — the factory tests the scope.
    keepPreviousWithinScope: true,
    cadenceMs
  });
}
